export const visit = (vm, at) => {
at({ "de": { "priceComponents": { "pricePerMonth": "{{price}}/Monat", "pricePerMonthPerSeat": "{{price}}/Monat/Lizenz", "subtexts": { "startsAt": "Ab" } } } });
};